import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import { useTranslation } from '../i18n/TranslationContext';
import CancelIcon from '@mui/icons-material/Cancel';
import { discardPendingConversion } from '../tracking/tracking';

const PaymentFailed: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const error = searchParams.get('error');

  useEffect(() => {
    // Log payment failure details for debugging
    console.log('Payment failed', { token, error });
    // Il pagamento non è andato a buon fine: nessuna conversione da tracciare
    discardPendingConversion();
  }, [token, error]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <CancelIcon
              sx={{
                fontSize: 80,
                color: 'error.main',
              }}
            />
          </Box>

          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            {t('esito.ko_titolo', 'Pagamento Non Riuscito')}
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {t('esito.ko_testo', 'Si è verificato un problema durante il processo di pagamento. La tua registrazione non è stata completata.')}
          </Typography>

          {error && (
            <Typography variant="body2" color="error" sx={{ mb: 3, p: 2, bgcolor: 'error.lighter', borderRadius: 1 }}>
              {t('esito.errore', 'Errore')}: {error}
            </Typography>
          )}

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {t('esito.riprova_testo', 'Puoi riprovare oppure contattare il supporto per assistenza.')}
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate(-1)}
            >
              {t('esito.riprova', 'Riprova')}
            </Button>

            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate('/')}
            >
              {t('esito.home', 'Torna alla Home')}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentFailed;
